import { GetProtegesQuery } from '%context/Connections/__generated__/getProteges.generated';

import {
	GetInvitations_currentUser_friendshipRequestsReceived,
	GetInvitations_currentUser_superPalOf,
	GetInvitations_currentUser_superPalOf_friendshipRequestsReceived,
} from '%context/Invitations/__generated__/GetInvitations';

type CareReceiverInvite = GetInvitations_currentUser_superPalOf_friendshipRequestsReceived & {
	toUser: GetInvitations_currentUser_superPalOf;
};

type Section<Type extends DataItem> = {
	title: string;
	data: Type['data'][];
	type: Type['type'];
};

enum DataType {
	ReceivedInvites = 'ReceivedInvites',
	CareReceiverInvites = 'CareReceiverInvites',
	CareReceiverImportToOrganisationInvites = 'CareReceiverImportToOrganisationInvites',
	Friends = 'Friends',
}

type DataItem =
	| {
			data: GetInvitations_currentUser_friendshipRequestsReceived;
			type: DataType.ReceivedInvites;
	  }
	| {
			data: CareReceiverInvite;
			type: DataType.CareReceiverInvites;
	  }
	| {
			data: CareReceiverInvite;
			type: DataType.CareReceiverImportToOrganisationInvites;
	  }
	| {
			data: { user: GetProtegesQuery['currentUser']['proteges'][number]; endDate: number | null };
			type: DataType.Friends;
	  };

enum PlaceholderType {
	Title,
	Divider,
}

type PlaceholderItem =
	| {
			title: string;
			type: PlaceholderType.Title;
	  }
	| {
			type: PlaceholderType.Divider;
	  };

type Item = PlaceholderItem | DataItem;

export type { CareReceiverInvite, Section, DataItem, PlaceholderItem, Item };

export { DataType, PlaceholderType };
